var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 114,
    viewBox: "0 0 142 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.725 111.139H7.27405C4.90367 111.139 2.98193 109.218 2.98193 106.847V6.44739C2.98193 4.07701 4.90367 2.15527 7.27405 2.15527H134.725C137.096 2.15527 139.017 4.07701 139.017 6.44739V106.847C139.017 109.218 137.096 111.139 134.725 111.139Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3311 111.139H7.27405C4.90367 111.139 2.98193 109.218 2.98193 106.847V6.44739C2.98193 4.07701 4.90367 2.15527 7.27405 2.15527H51.3311V111.139Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.017 6.44739V23.299H2.98193V6.44739C2.98193 4.07701 4.90367 2.15527 7.27405 2.15527H134.725C137.096 2.15527 139.017 4.07701 139.017 6.44739Z",
    fill: "#006F8F",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.725 112.737H7.27376C4.02674 112.737 1.38428 110.094 1.38428 106.847V6.4471C1.38428 3.20008 4.02674 0.557617 7.27376 0.557617H134.725C137.972 0.557617 140.615 3.20008 140.615 6.4471V106.847C140.615 110.094 137.972 112.737 134.725 112.737ZM7.27376 2.75236C5.23604 2.75236 3.57902 4.40938 3.57902 6.4471V106.847C3.57902 108.885 5.23604 110.542 7.27376 110.542H134.725C136.763 110.542 138.42 108.885 138.42 106.847V6.4471C138.42 4.40938 136.763 2.75236 134.725 2.75236H7.27376Z",
    fill: "#084E64",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5506 13.4435C19.5506 15.0908 18.2153 16.4261 16.568 16.4261C14.9208 16.4261 13.5854 15.0908 13.5854 13.4435C13.5854 11.7963 14.9208 10.4609 16.568 10.4609C18.2153 10.4609 19.5506 11.7963 19.5506 13.4435Z",
    fill: "white",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6698 13.4435C30.6698 15.0908 29.3344 16.4261 27.6872 16.4261C26.0399 16.4261 24.7046 15.0908 24.7046 13.4435C24.7046 11.7963 26.0399 10.4609 27.6872 10.4609C29.3344 10.4609 30.6698 11.7963 30.6698 13.4435Z",
    fill: "white",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.787 13.4435C41.787 15.0908 40.4516 16.4261 38.8044 16.4261C37.1571 16.4261 35.8218 15.0908 35.8218 13.4435C35.8218 11.7963 37.1571 10.4609 38.8044 10.4609C40.4516 10.4609 41.787 11.7963 41.787 13.4435Z",
    fill: "white",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.315 16.8558H84.3159V10.0303H127.315C127.921 10.0303 128.413 10.5217 128.413 11.1276V15.7587C128.413 16.3645 127.921 16.8558 127.315 16.8558Z",
    fill: "white",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0334 16.3127L82.7938 16.073L82.4824 16.2069C81.0814 16.8092 79.3956 16.5408 78.2563 15.4016C76.7629 13.9081 76.7629 11.4769 78.2563 9.98339C79.7498 8.48991 82.181 8.48991 83.6745 9.98339C84.8137 11.1226 85.0821 12.8084 84.4796 14.2097L84.3457 14.5211L84.5853 14.7608L85.9744 16.1499C86.4028 16.5782 86.4028 17.2734 85.9744 17.7018C85.5461 18.13 84.8513 18.1302 84.4225 17.7018C84.4225 17.7017 84.4225 17.7017 84.4224 17.7017L83.0334 16.3127ZM82.1226 11.5353C81.4842 10.8969 80.4466 10.8969 79.8082 11.5353C79.1699 12.1737 79.1699 13.2113 79.8082 13.8497C80.4466 14.488 81.4842 14.488 82.1226 13.8497C82.761 13.2113 82.761 12.1737 82.1226 11.5353Z",
    fill: "#084E64",
    stroke: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4055 60.0752H129.233C129.839 60.0752 130.331 60.5666 130.331 61.1726C130.331 61.7785 129.839 62.2699 129.233 62.2699H62.4055C61.7996 62.2699 61.3081 61.7785 61.3081 61.1726C61.3081 60.5666 61.7996 60.0752 62.4055 60.0752Z",
    fill: "#084E64",
    stroke: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4055 66.6211H129.233C129.839 66.6211 130.331 67.1125 130.331 67.7185C130.331 68.3244 129.839 68.8158 129.233 68.8158H62.4055C61.7996 68.8158 61.3081 68.3244 61.3081 67.7185C61.3081 67.1125 61.7996 66.6211 62.4055 66.6211Z",
    fill: "#084E64",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4055 73.166H129.233C129.839 73.166 130.331 73.6575 130.331 74.2634C130.331 74.8693 129.839 75.3608 129.233 75.3608H62.4055C61.7996 75.3608 61.3081 74.8693 61.3081 74.2634C61.3081 73.6575 61.7996 73.166 62.4055 73.166Z",
    fill: "#084E64",
    stroke: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4055 85.0303H129.233C129.839 85.0303 130.331 85.5217 130.331 86.1276C130.331 86.7336 129.839 87.225 129.233 87.225H62.4055C61.7996 87.225 61.3081 86.7336 61.3081 86.1276C61.3081 85.5217 61.7996 85.0303 62.4055 85.0303Z",
    fill: "#084E64",
    stroke: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4055 91.5762H129.233C129.839 91.5762 130.331 92.0676 130.331 92.6735C130.331 93.2795 129.839 93.7709 129.233 93.7709H62.4055C61.7996 93.7709 61.3081 93.2795 61.3081 92.6735C61.3081 92.0676 61.7996 91.5762 62.4055 91.5762Z",
    fill: "#084E64",
    stroke: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4055 98.1201H129.233C129.839 98.1201 130.331 98.6116 130.331 99.2175C130.331 99.8234 129.839 100.315 129.233 100.315H62.4055C61.7996 100.315 61.3081 99.8234 61.3081 99.2175C61.3081 98.6116 61.7996 98.1201 62.4055 98.1201Z",
    fill: "#084E64",
    stroke: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4055 35.123H129.233C129.839 35.123 130.331 35.6145 130.331 36.2204C130.331 36.8263 129.839 37.3178 129.233 37.3178H62.4055C61.7996 37.3178 61.3081 36.8263 61.3081 36.2204C61.3081 35.6145 61.7996 35.123 62.4055 35.123Z",
    fill: "#084E64",
    stroke: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4055 41.6689H129.233C129.839 41.6689 130.331 42.1604 130.331 42.7663C130.331 43.3722 129.839 43.8637 129.233 43.8637H62.4055C61.7996 43.8637 61.3081 43.3722 61.3081 42.7663C61.3081 42.1604 61.7996 41.6689 62.4055 41.6689Z",
    fill: "#084E64",
    stroke: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4055 48.2129H129.233C129.839 48.2129 130.331 48.7043 130.331 49.3103C130.331 49.9162 129.839 50.4076 129.233 50.4076H62.4055C61.7996 50.4076 61.3081 49.9162 61.3081 49.3103C61.3081 48.7043 61.7996 48.2129 62.4055 48.2129Z",
    fill: "#084E64",
    stroke: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3566 62.4473H41.9305C42.5366 62.4473 43.0282 62.9388 43.0282 63.5446C43.0282 64.1506 42.5368 64.642 41.9308 64.642H15.3566C14.7507 64.642 14.2593 64.1506 14.2593 63.5446C14.2593 62.9387 14.7507 62.4473 15.3566 62.4473Z",
    fill: "#084E64",
    stroke: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3566 68.9932H35.2216C35.8276 68.9932 36.3193 69.4847 36.3193 70.0905C36.3193 70.6965 35.8278 71.1879 35.2219 71.1879H15.3566C14.7507 71.1879 14.2593 70.6965 14.2593 70.0905C14.2593 69.4846 14.7507 68.9932 15.3566 68.9932Z",
    fill: "#084E64",
    stroke: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3566 75.5371H35.2216C35.8276 75.5371 36.3193 76.0287 36.3193 76.6345C36.3193 77.2404 35.8278 77.7319 35.2219 77.7319H15.3566C14.7507 77.7319 14.2593 77.2404 14.2593 76.6345C14.2593 76.0286 14.7507 75.5371 15.3566 75.5371Z",
    fill: "#084E64",
    stroke: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3566 85.0303H41.9305C42.5366 85.0303 43.0282 85.5218 43.0282 86.1276C43.0282 86.7336 42.5368 87.225 41.9308 87.225H15.3566C14.7507 87.225 14.2593 86.7336 14.2593 86.1276C14.2593 85.5217 14.7507 85.0303 15.3566 85.0303Z",
    fill: "#084E64",
    stroke: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3566 91.5762H41.9305C42.5366 91.5762 43.0282 92.0677 43.0282 92.6735C43.0282 93.2795 42.5368 93.7709 41.9308 93.7709H15.3566C14.7507 93.7709 14.2593 93.2795 14.2593 92.6735C14.2593 92.0676 14.7507 91.5762 15.3566 91.5762Z",
    fill: "#084E64",
    stroke: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3566 98.1211H41.9305C42.5366 98.1211 43.0282 98.6127 43.0282 99.2185C43.0282 99.8244 42.5368 100.316 41.9308 100.316H15.3566C14.7507 100.316 14.2593 99.8244 14.2593 99.2185C14.2593 98.6125 14.7507 98.1211 15.3566 98.1211Z",
    fill: "#084E64",
    stroke: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8313 112.737C51.2253 112.737 50.7339 112.246 50.7339 111.64V23.7995C50.7339 23.1933 51.2253 22.7021 51.8313 22.7021C52.4373 22.7021 52.9286 23.1933 52.9286 23.7995V111.64C52.9286 112.246 52.4373 112.737 51.8313 112.737Z",
    fill: "#084E64",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.2612,
    y: 30.1162,
    width: 27.5258,
    height: 26.1318,
    rx: 4.5,
    fill: "#006F8F",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.141e02e662d1b63c4c723b7cc34c7439.svg";
export { ForwardRef as ReactComponent };